import { ACCOUNT_INVOICE_READ } from 'client/redux/account/constants';
import * as actionCreators from 'client/redux/account/actionCreators';

export const accountInvoiceRead = (id) => dispatch => {
  return dispatch(actionCreators.accountInvoiceRead(ACCOUNT_INVOICE_READ, id));
};
